var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedicineIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.62353 16.4421L16.4421 6.62353M12.8378 22.6564L22.6564 12.8378M16.2764 26.0742C17.5823 27.3411 19.3341 28.0435 21.1535 28.0297C22.973 28.0159 24.7139 27.287 26.0005 26.0005C27.287 24.7139 28.0159 22.973 28.0297 21.1535C28.0435 19.3341 27.3411 17.5823 26.0742 16.2764L13.0035 3.20567C11.6976 1.93879 9.94578 1.2364 8.12637 1.2502C6.30696 1.264 4.56599 1.99288 3.27944 3.27944C1.99288 4.56599 1.264 6.30696 1.2502 8.12637C1.2364 9.94578 1.93879 11.6976 3.20567 13.0035L16.2764 26.0742Z",
    stroke: "black",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedicineIcon);
export default __webpack_public_path__ + "static/media/medicine-icon.f51ecd34d70595447bca984a8ae38da9.svg";
export { ForwardRef as ReactComponent };